export const name = 'rnInstructionsService';
export default function rnInstructionsService(
  $injector,
  $q
) {
  'ngInject';

  const URL = 'url';
  const SVG_ICON = 'svg';

  const MODEL_TYPES = {
    LatexPrinter: {
      'M0E30A': 'LatexLV',
      '1QE01A': 'LatexLV',
      '1QE01B': 'LatexLV',
      '1QE01C': 'LatexLV',
      '1QE01D': 'LatexLV',
      'B4H69A': 'LatexLV',
      'V7L46A': 'LatexLV',
      'V7L46B': 'LatexLV',
      'V7L46C': 'LatexLV',
      'V7L46D': 'LatexLV',
      'E2X76A': 'LatexLV',
      'V7L47A': 'LatexLV',
      'V7L47B': 'LatexLV',
      'V7L47C': 'LatexLV',
      'V7L47D': 'LatexLV',
      'B4H70A': 'LatexLV',
      'V8L39A': 'LatexLV',
      'V8L39B': 'LatexLV',
      'V8L39C': 'LatexLV',
      'V8L39D': 'LatexLV',
      'L4R41A': 'LatexLV',
      'V8N83A': 'LatexLV',
      'V8N83B': 'LatexLV',
      'V8N83C': 'LatexLV',
      'V8N83D': 'LatexLV',
      'M0E29A': 'LatexLV',
      'M0E29B': 'LatexLV',
      'M0E29C': 'LatexLV',
      'M0E29D': 'LatexLV',
      'N2G70A': 'LatexLV',
      'N2G70B': 'LatexLV',
      'N2G70C': 'LatexLV',
      'N2G70D': 'LatexLV',
      'K4T88A': 'LatexMV',
      'CZ056A': 'LatexMV',
      'L2E27A': 'LatexMV',
      '1HA06A': 'LatexMV',
      'K4G10A': 'LatexMV',
      '1HA07A': 'LatexMV',
      '3DB03A': 'LatexMV',
      'K0Q45A': 'LatexR',
      'K0Q46A': 'LatexR',
      'K0Q47A': 'LatexR',
      'K0Q48A': 'LatexR',
      'Y0U22A': 'DesignJet',
      'Y0U23A': 'DesignJet',
      'Y0U21A': 'DesignJet',
      '3XD61A': 'DesignJet',
    },
    TextilePrinter: {
      '2ET72A': 'Textile',
      '2ET73A': 'Textile',
      '2ET73B': 'Textile',
      '4DC17A': 'TextileMV',
    },
    DesignjetPrinter: {
      'T8W15A': 'DesignJet',
      'T8W15B': 'DesignJet',
      'T8W16A': 'DesignJet',
      'T8W18A': 'DesignJet',
      'T8W18B': 'DesignJet',
      'W3Z71A': 'DesignJet',
      'W3Z72A': 'DesignJet',
      'W3Z71B': 'DesignJet',
      'X9D24A': 'DesignJet',
      'X9D24B': 'DesignJet',
      'T8W15D': 'DesignJet',
      'T8W16D': 'DesignJet',
      'W3Z71D': 'DesignJet',
	  '2RM82A':  'DesignJet',
	  '2QU25A':  'DesignJet',
    },
    PageWideXLPrinter: {
	  '4VW19A': 'DesignJet',
	  '4VW19F': 'DesignJet',
	  '4VW19H': 'DesignJet',
	  '4VW20A':  'DesignJet',
	  '4VW20F':  'DesignJet',
	  '4VW20H':  'DesignJet',
	  '4VW21A':  'DesignJet',
	  '4VW21H':  'DesignJet',
    },
  };

  const INSTRUCTIONS = {

    // DesignJet
    DesignJet : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_DesignJet_QR_Step1'},
          {key: 'devices.devices.DI_DesignJet_QR_Step2'},
          {key: 'devices.devices.DI_DesignJet_QR_Step3'},
          {key: 'devices.devices.DI_DesignJet_QR_Step4'},
          {key: 'devices.devices.DI_DesignJet_QR_Step5'},
          {key: 'devices.devices.DI_DesignJet_QR_Step6'},
          {key: 'devices.devices.DI_DesignJet_QR_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_DesignJet_SC_Step1'},
          {key: 'devices.devices.DI_DesignJet_SC_Step2'},
          {key: 'devices.devices.DI_DesignJet_SC_Step3'},
          {key: 'devices.devices.DI_DesignJet_SC_Step4'},
          {key: 'devices.devices.DI_DesignJet_SC_Step5'},
          {key: 'devices.devices.DI_DesignJet_SC_Step6'},
          {key: 'devices.devices.DI_DesignJet_SC_Step7'},
          {key: 'devices.devices.DI_DesignJet_SC_Step8'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
    },

    // Latex 110, 115, 310, 315, 330, 335, 360, 365, 370, 375, 560, 570, 1500, 3000, 3100, 3200, 3500, 3600, 3800
    LatexLV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_QR_Step1'},
          {key: 'devices.devices.DI_LatexLV_QR_Step2'},
          {key: 'devices.devices.DI_LatexLV_QR_Step3'},
          {key: 'devices.devices.DI_LatexLV_QR_Step4'},
          {key: 'devices.devices.DI_LatexLV_QR_Step5'},
          {key: 'devices.devices.DI_LatexLV_QR_Step6'},
          {key: 'devices.devices.DI_LatexLV_QR_Step7'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_SC_Step1'},
          {key: 'devices.devices.DI_LatexLV_SC_Step2'},
          {key: 'devices.devices.DI_LatexLV_SC_Step3'},
          {key: 'devices.devices.DI_LatexLV_SC_Step4'},
          {key: 'devices.devices.DI_LatexLV_SC_Step5'},
          {key: 'devices.devices.DI_LatexLV_SC_Step6'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sn: {
        postActivation: {
          titles: ['devices.devices.DI_LatexLV_SN_PA_Title1', 'devices.devices.DI_LatexLV_SN_PA_Title2'],
          steps:[
            {key:'devices.devices.DI_LatexLV_SN_PA_Step1'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step2'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step3'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step4'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step5'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step6',
              subSteps:[
                {key:'devices.devices.DI_LatexLV_SN_PA_Step6a'},
                {
                  key:'devices.devices.DI_LatexLV_SN_PA_Step6b',
                  resolve:{addLatexInternalId},
                },
              ]
            },
            {key:'devices.devices.DI_LatexLV_SN_PA_Step7'},
            {key:'devices.devices.DI_LatexLV_SN_PA_Step8'},
          ],
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      }
    },
    LatexMV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_QR_Step1'},
          {key: 'devices.devices.DI_LatexMV_QR_Step2'},
          {key: 'devices.devices.DI_LatexMV_QR_Step3'},
          {key: 'devices.devices.DI_LatexMV_QR_Step4'},
          {key: 'devices.devices.DI_LatexMV_QR_Step5'},
          {key: 'devices.devices.DI_LatexMV_QR_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
          {
            key: 'devices.devices.DI_LatexMV_SC_Step5',
            subSteps: [
              {
                key: 'devices.devices.DI_LatexMV_SC_Step5a',
                type: URL,
              }
            ]
          },
          {key: 'devices.devices.DI_LatexMV_SC_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sn: {
        postActivation: {
          titles: ['devices.devices.DI_LatexMV_SN_PA_Title1', 'devices.devices.DI_LatexMV_SN_PA_Title2'],
          steps: [
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step1'},
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step2'},
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step3'},
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step4'},
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step5'},
            {
              key: 'devices.devices.DI_LatexMV_SN_PA_Step6',
              subSteps: [
                {key: 'devices.devices.DI_LatexMV_SN_PA_Step6a'},
                {
                  key: 'devices.devices.DI_LatexMV_SN_PA_Step6b',
                  resolve: { addLatexInternalId },
                },
              ]
            },
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step7'},
            {key: 'devices.devices.DI_LatexMV_SN_PA_Step8'},
          ],
          notes: [
            {key: 'devices.devices.DI_LatexMV_SN_PA_Note1'},
            {key: 'devices.devices.DI_DataAccuracyNote'}
          ],
        }
      }
    },
    LatexR: {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexR_QR_Step1'},
          {
            key: 'devices.devices.DI_LatexR_QR_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_LatexR_QR_Step3'},
          {key: 'devices.devices.DI_LatexR_QR_Step4'},
          {key: 'devices.devices.DI_LatexR_QR_Step5'},
          {key: 'devices.devices.DI_LatexR_QR_Step6'},
          {key: 'devices.devices.DI_LatexR_QR_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {
            key: 'devices.devices.DI_LatexR_SC_Step1',

          },
          {
            key: 'devices.devices.DI_LatexR_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_LatexR_SC_Step3'},
          {key: 'devices.devices.DI_LatexR_SC_Step4'},
          {key: 'devices.devices.DI_LatexR_SC_Step5'},
          {key: 'devices.devices.DI_LatexR_SC_Step6'},
          {key: 'devices.devices.DI_LatexR_SC_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      }
    },
    Textile: {
      qr: {
        steps: [
          {key: 'devices.devices.DI_Textile_QR_Step1'},
          {key: 'devices.devices.DI_Textile_QR_Step2'},
          {key: 'devices.devices.DI_Textile_QR_Step3'},
          {key: 'devices.devices.DI_Textile_QR_Step4'},
          {key: 'devices.devices.DI_Textile_QR_Step5'},
          {key: 'devices.devices.DI_Textile_QR_Step6'},
          {key: 'devices.devices.DI_Textile_QR_Step7'},
          {key: 'devices.devices.DI_Textile_QR_Step8'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_Textile_SC_Step1'},
          {
            key: 'devices.devices.DI_Textile_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_Textile_SC_Step3'},
          {key: 'devices.devices.DI_Textile_SC_Step4'},
          {key: 'devices.devices.DI_Textile_SC_Step5'},
          {key: 'devices.devices.DI_Textile_SC_Step6'},
          {key: 'devices.devices.DI_Textile_SC_Step7'},
          {key: 'devices.devices.DI_Textile_SC_Step8'},
          {key: 'devices.devices.DI_Textile_SC_Step9'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      }
    },
    TextileMV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_QR_Step1'},
          {key: 'devices.devices.DI_LatexMV_QR_Step2'},
          {key: 'devices.devices.DI_LatexMV_QR_Step3'},
          {key: 'devices.devices.DI_LatexMV_QR_Step4'},
          {key: 'devices.devices.DI_LatexMV_QR_Step5'},
          {key: 'devices.devices.DI_LatexMV_QR_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
          {
            key: 'devices.devices.DI_LatexMV_SC_Step5',
            subSteps: [
              {
                key: 'devices.devices.DI_LatexMV_SC_Step5a',
                type: URL,
              }
            ]
          },
          {key: 'devices.devices.DI_LatexMV_SC_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      }
    },
  };

  const service = {
    getInstructions,
    hasPostActivationInstructions,
    getPostInstructions,
    getInstallMethods,
  };
  return service;

  function getInstallMethods(type, model) {
    let methods = {
      qr: false,
      sc: false,
      sn: true
    };

    if (!_.get(MODEL_TYPES, `${type}.${model}`)) {
      return methods;
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    if (instructions) {
      methods = {
        qr: instructions.qr !== undefined,
        sc: instructions.sc !== undefined,
        sn: instructions.sn !== undefined
      };
    }

    return methods;
  }

  function hasPostActivationInstructions(type, model, method) {
    if (!_.get(MODEL_TYPES, `${type}.${model}`)) {
      return false;
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    if (!instructions) {
      return false;
    }

    if (!instructions[method]) {
      return false;
    }

    if (!instructions[method].postActivation) {
      return false;
    }

    return true;
  }

  function getInstructions(type, model) {
    if (!(type && model)) {
      return undefined;
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    let promises = [];
    Object.keys(instructions).forEach(method => {
      if (instructions[method].steps) {
        promises = promises.concat(doResolve(instructions[method].steps));
      }

      let postActivationSteps = _.get(instructions[method], 'postActivation.steps');
      if (postActivationSteps) {
        promises = promises.concat(doResolve(postActivationSteps));
      }
    });

    return $q.all(promises).then(() => {
      return instructions;
    });
  }

  function getPostInstructions(type, model, method) {
    if (!(type && model && method)) {
      return undefined;
    }

    return getInstructions(type, model).then(instructions => {
      if (instructions && instructions[method] && instructions[method].postActivation) {
        return instructions[method].postActivation;
      }
      else {
        return undefined;
      }
    });
  }

  function doResolve(steps) {
    let promises = [];
    steps.forEach(step => {
      if (step.resolve) {
        Object.keys(step.resolve).forEach(r => {
          let promise = $injector.invoke(step.resolve[r], null, { step });
          promises.push(promise);
        });
      }

      if (step.subSteps) {
        promises = promises.concat(doResolve(step.subSteps, $injector));
      }
    });

    return promises;
  }

  // Helpers (will be invoked with $injector)
  function addLatexInternalId(rnOrganization, step) {
    'ngInject';

    return rnOrganization.getOrganization(false).then(resp => {
      let org = resp.data;
      if (!org.internalIds) {
        org.internalIds = [];
      }

      let latexInternalId = org.internalIds.find(id => id.gbu === 'Latex');
      if (latexInternalId) {
        step.values = [latexInternalId.gbuInternalId];
      }
    });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/device/instructions.service.js